import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';

export const useAutocompleteData = <T>(
    queryKeyPrefix: string,
    fetchFunction: (searchQuery: string) => Promise<T[]>,
    enabled = true
) => {
    const [searchQuery, setSearchQuery] = useState('');

    const { data: options = [], isLoading } = useQuery({
        queryKey: [queryKeyPrefix, searchQuery],
        queryFn: () => fetchFunction(searchQuery),
        staleTime: 60000,
        enabled: enabled ?? true
    });

    return {
        options,
        isLoading,
        setSearchQuery,
    };
};
